export default __webpack_public_path__ + "static/media/chanchito.87179076.png";